import React, { Component, useState, useMemo } from 'react';
import { SearchInput } from '@ifixit/toolbox';
import { color, fontSize, lineHeight, space, breakpoint } from '@core-ds/primitives';
import styled from 'styled-components';

import deviceNavigator from '../../Shared/device_navigator';

const MOBILE = `@media only screen and (max-width: ${breakpoint.sm})`;

const heroContentWidth = `
   width: ${breakpoint.sm};
   ${MOBILE} {
      width: 90%;
   }
`;

const heroTextFontSize = `
   font-size: ${fontSize[7]};
   line-height: ${lineHeight.tight};

   ${MOBILE} {
      font-size: ${fontSize[5]};
   }
`;

const heroTextAlign = `
   text-align: center;
   ${MOBILE} {
      text-align: left;
   }
`;

const HeroTextContainer = styled.h1`
   ${heroContentWidth};
   ${heroTextFontSize};
   ${heroTextAlign};
   font-family: Archivo Black;
   font-style: normal;
   font-weight: normal;
   padding-bottom: ${space[5]};
   margin: 0;
   color: ${color.white};
`;

const heroText = _js('Repair guides for every thing, written by everyone.');

const SearchWrapper = styled.form`
   ${heroContentWidth};
`;

const Explore = styled.div`
   display: block;
   margin-top: ${space[4]};
   ${MOBILE} {
      margin-top: ${space[3]};
   }

   font-size: ${fontSize[2]};
   line-height: ${lineHeight.tight};
   ${heroTextAlign};
   color: white;
   opacity: 0.9;
`;

const ExploreLink = styled.a`
   color: white;
   :visited {
      color: white;
   }

   text-decoration: underline;
   cursor: pointer;
`;

// c.f. https://stackoverflow.com/questions/9038625/detect-if-device-is-ios/9039885#9039885
let autoFocus = !(navigator.platform && /iphone|ipod|ipad/i.test(navigator.platform));

const searchInputProps = {
   autoComplete: 'off',
   autoCorrect: 'off',
   autoCapitalize: 'off',
   autoFocus,
   style: {
      height: space[8],
   },
   /* whitelist hotjar keystroke collection */
   'data-hj-whitelist': true,
   'aria-label': 'Search',
};

const handleSubmit = value => {
   return event => {
      event.preventDefault();
      document.location = '/Search/' + encodeURIComponent(value);
   };
};

const breakUpExploreCategoriesString = () => {
   /* Translators: %1 and %2 provide the start and end of a link */
   const translatedString = _js('or %1explore categories%2');
   const pieces = /^(.*)%1(.*)%2(.*)$/.exec(translatedString);
   return {
      beforeExplore: pieces && pieces[1],
      exploreCategories: (pieces && pieces[2]) || translatedString.replace(/%\d+/, ''),
      afterExplore: pieces && pieces[3],
   };
};

export default function HomePageSearchHero(props) {
   const [value, setValue] = useState('');
   const { beforeExplore, exploreCategories, afterExplore } = useMemo(
      breakUpExploreCategoriesString
   );
   /* Translators: Prompting the user to search for the phrase %1 */
   const prompt = _js('Try "%1"', props.prompt);
   return (
      <React.Fragment>
         <HeroTextContainer>{heroText}</HeroTextContainer>
         <SearchWrapper action="Search" onSubmit={handleSubmit(value)}>
            <SearchInput
               value={value}
               onChange={event => setValue(event.target.value)}
               placeholder={prompt}
               {...searchInputProps}
            />
            <Explore>
               {beforeExplore}
               <ExploreLink href="#" onClick={deviceNavigator}>
                  {exploreCategories}
               </ExploreLink>
               {afterExplore}
            </Explore>
         </SearchWrapper>
      </React.Fragment>
   );
}
